var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelOrderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30800_175135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9963 23.994C8.81382 23.9969 5.76084 22.7339 3.51048 20.4835C1.26011 18.2332 -0.00285839 15.1802 4.85777e-06 11.9977V11.7578C0.0981202 6.94992 3.05642 2.66476 7.51732 0.868804C11.9782 -0.927155 17.0804 0.112837 20.4825 3.51152C23.9164 6.94256 24.9441 12.1049 23.0861 16.5894C21.2281 21.074 16.8505 23.9968 11.9963 23.994ZM11.9963 13.6892L14.3962 16.0891C14.7868 16.4796 15.4199 16.4796 15.8105 16.0891L16.0877 15.8119C16.4782 15.4213 16.4782 14.7882 16.0877 14.3976L13.6878 11.9977L16.0877 9.59777C16.4782 9.20724 16.4782 8.57408 16.0877 8.18355L15.8105 7.90629C15.4199 7.51576 14.7868 7.51576 14.3962 7.90629L11.9963 10.3062L9.59637 7.90629C9.20585 7.51576 8.57269 7.51576 8.18216 7.90629L7.9049 8.18355C7.51437 8.57408 7.51437 9.20724 7.9049 9.59777L10.3048 11.9977L7.9049 14.3976C7.51437 14.7882 7.51437 15.4213 7.9049 15.8119L8.18216 16.0891C8.57269 16.4796 9.20585 16.4796 9.59637 16.0891L11.9963 13.6892Z",
    fill: "#D2434D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30800_175135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelOrderIcon);
export default __webpack_public_path__ + "static/media/cancel-order-icon.e79d6a2210b7444a2476d51b6b610c92.svg";
export { ForwardRef as ReactComponent };